<template>
  <div class="warning">
    <header class="header">
      <i class="icon-fanhui icon iconfont" @click="returnRank"></i>
      <h2>预警项目详情</h2>
    </header>
    <div class="warning-content" >
      <p>项目名称：{{data.p_name}}</p>
      <p>逾期时间：{{Number(data.seconds).toFixed(0)}}天</p>
      <p>制作部：{{data.group_name}}</p>
      <p>销售：{{data.sales}}</p>
      <p>项目状态：{{status[data.status]}}</p>
      <p>项目金额：{{ (data.p_money/10000).toFixed(2) }}万</p>
      <p>已开发票待回款:{{ (data.y_no_money/10000).toFixed(2) }}万</p>
      <p>已回款金额：{{ (data.b_money/10000).toFixed(2) }}万</p>
      <p>最后开票时间：{{Number(data.seconds).toFixed(0)}}天</p>
      <p>预警原因：{{showinfo(data.alert)}}</p>
    </div>



  </div>

</template>
<script>
  export default{
    data(){
      return {
        // list:[],
        status:{
          0:'待处理',
          1:'开发中',
          2:'已交付',
          3:'已暂停',
          4:'已关闭',
          5:'已完结',
        }, //状态
        alert_info:{
          1:'制作周期超过45天',
          2:'到达回款计划时间未回款',
          3:'已开票未回款累计时间超过30天',
          4:'订单审核通过后合同超过30天未录入',
        }

      }　
    },

    methods:{
      returnRank(){
        this.$router.go(-1)
      },
      showinfo(arr){
        let info = ''
        if(arr.length ==0){
          return "无"
        }
        else if(arr.length > 0) {
          arr.forEach(item => {
            info = info +this.alert_info[item]
          })
          return info
        }
      //  console.log(info)

      }

    },
    created () {
      this.data = this.$route.params.data
      //console.log(this.data)
    },

  }

</script>
<style scoped>
  .warning{
    width:100%;
    height: 100%;
    background: #fff;
    font-size: 16px;
  }
  .header{
    width:100%;
    background: #5483D2;
    position: relative;

  }
  .header>h2{
    color:#fff;
    text-align: center;
    font-size:16px;
    height:1.1875rem;
    line-height: 1.1875rem;

  }
  .icon-fanhui{
    color:#fff;
    position: absolute;
    bottom: 12px;
  }
  .warning-content{
    padding:0.5rem;
  }
  .warning-content>p{
    margin:0.8rem 0 ;
  }
</style>



// WEBPACK FOOTER //
// src/components/drillPage/EarlyWarningProject.vue